import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowRight } from "lucide-react";

export default function Contact() {
  useEffect(() => {
    document.title = "Contact Truestays | Talk to Our Team";
    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.name = name; document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setMeta("description", "Contact the Truestays team about short-let management, a free income estimate or an existing property. Email hello@truestays.co.uk.");
    setMeta("robots", "index, follow");
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
    canonical.href = window.location.origin + "/contact";
  }, []);

  return (
    <div style={{ background: "#fff", minHeight: "100vh" }}>
      <section
        style={{
          position: "relative",
          paddingTop: "clamp(140px, 16vw, 180px)",
          paddingBottom: "clamp(48px, 6vw, 80px)",
          paddingLeft: "clamp(20px, 5vw, 80px)",
          paddingRight: "clamp(20px, 5vw, 80px)",
          backgroundColor: "#f4f2f0",
        }}
      >
        <div style={{ maxWidth: 1200, margin: "0 auto", textAlign: "center" }}>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", color: "#888", marginBottom: 16, marginTop: 0 }}>
            Contact
          </p>
          <h1 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(36px, 5.5vw, 64px)", lineHeight: 1.05, letterSpacing: "-0.03em", color: "#1A1A1A", margin: "0 auto 20px", maxWidth: 820 }}>
            Talk to the Truestays team
          </h1>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "clamp(16px, 2vw, 19px)", fontWeight: 400, color: "#555", lineHeight: 1.65, maxWidth: 580, margin: "0 auto" }}>
            Whether you own one flat or a portfolio, we're happy to talk through what your property could earn. No pressure, no hard sell.
          </p>
        </div>
      </section>

      <section style={{ backgroundColor: "#fff", padding: "clamp(48px, 6vw, 80px) clamp(20px, 5vw, 80px)" }}>
        <div style={{ maxWidth: 1000, margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }} className="contact-grid">
          <div style={{ background: "#F4F1E7", borderRadius: 16, padding: "32px 28px", border: "1px solid #E8E4D5" }}>
            <div style={{ width: 38, height: 38, borderRadius: 10, background: "#fff", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
              <Mail size={18} color="#112215" strokeWidth={1.8} />
            </div>
            <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: 21, color: "#112215", margin: "0 0 10px" }}>Email us</h2>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#5C7268", lineHeight: 1.6, margin: "0 0 18px" }}>
              The quickest way to reach us. We reply to every enquiry within one working day.
            </p>
            <a
              href="mailto:hello@truestays.co.uk"
              style={{ fontFamily: "'Inter', sans-serif", fontSize: 16, fontWeight: 600, color: "#112215", textDecoration: "underline" }}
            >
              hello@truestays.co.uk
            </a>
          </div>

          <div style={{ background: "#F4F1E7", borderRadius: 16, padding: "32px 28px", border: "1px solid #E8E4D5" }}>
            <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: 21, color: "#112215", margin: "0 0 10px" }}>Need help with a booking or your account?</h2>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#5C7268", lineHeight: 1.6, margin: "0 0 18px" }}>
              Our support team handles guest and host enquiries seven days a week, and you can browse common questions any time.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <Link to="/support" style={{ fontFamily: "'Inter', sans-serif", fontSize: 15, fontWeight: 600, color: "#112215", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6 }}>
                Visit the support centre <ArrowRight size={14} />
              </Link>
              <Link to="/faqs" style={{ fontFamily: "'Inter', sans-serif", fontSize: 15, fontWeight: 600, color: "#112215", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6 }}>
                Read the FAQs <ArrowRight size={14} />
              </Link>
            </div>
          </div>
        </div>

        <div style={{ maxWidth: 1000, margin: "32px auto 0", textAlign: "center" }}>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "#888", lineHeight: 1.7, margin: 0 }}>
            Truestays Group Ltd. · Registered in England and Wales · Operating across Manchester, Liverpool, London and 16+ UK cities.
          </p>
        </div>
      </section>

      <style>{`
        @media (max-width: 720px) { .contact-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </div>
  );
}